<div class="cookie-policy-container h-100 w-100 overflow-auto bg-light mx-a">
  <cp-detail-header headline="Cookie Policy" class="w-100" />

  <div class="desktop-detail-wrapper flex-column gap-3 px-4 pb-4">
    <shared-labeled-value-inline-container
      class="w-100"
      contentStyleClass="bg-gray-5 p-4 flex-column gap-3"
      [hideHeader]="true">
      <div class="text-20 bold-800">Information about our use of cookies</div>
      <div class="text-14">
        <b>
          We use some necessary cookies to make our site work. We'd like to set analytics cookies to
          understand how you use this app.
        </b>
        <br />
        <br />
        A cookie is a small file containing letters and numbers that we store on your browser or
        your device's hard drive. These files contain information that is transferred from Mortgage
        Monitor to your device, allowing us to recognize you and remember your preferences for
        future visits.
      </div>
    </shared-labeled-value-inline-container>

    <shared-labeled-value-inline-container
      class="w-100"
      contentStyleClass="bg-gray-5 p-4 flex-column"
      [hideHeader]="true">
      <div class="text-20 bold-800 mb-4">We use the following cookies:</div>
      <div class="text-14 mb-2">
        <b>Strictly necessary cookies.</b> These are cookies that are required for the operation of
        our site. They include, for example, cookies that enable you to login securely to our site,
        prevent fraudulent use of login credentials, and protect user data from unauthorised
        parties.
      </div>

      <div class="cookies-table">
        <div class="cookies-table-header">
          <div>Provider</div>
          <div>Name</div>
          <div>Purpose</div>
          <div>Expiry</div>
        </div>
        <div class="cookies-table-body">
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>LAST_CHECKED_EMAIL</div>
            <div>Login</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>accessToken</div>
            <div>Login</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>signUpFlow</div>
            <div>Sign Up</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>signUpProperty</div>
            <div>Sign Up</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>signUpMortgage</div>
            <div>Sign Up</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>signUpSmartSearch</div>
            <div>Sign Up</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>signUpUser</div>
            <div>Sign Up</div>
            <div>-</div>
          </div>
          <div class="cookies-table-row">
            <div>Dashly</div>
            <div>allowCookies</div>
            <div>Cookie Consent</div>
            <div>-</div>
          </div>
        </div>
      </div>

      <div class="text-14 mt-5 mb-2">
        <b>Analytics/performance cookies.</b> These allow us to recognise and count the number of
        visitors and see how visitors move around our site when they are using it. This helps us to
        improve the way our site works, for example, by ensuring that users are finding what they
        are looking for easily.
      </div>

      <div class="cookies-table">
        <div class="cookies-table-header">
          <div>Provider</div>
          <div>Name</div>
          <div>Purpose</div>
          <div>Expiry</div>
        </div>
        <div class="cookies-table-body">
          <div class="cookies-table-row">
            <div>Google</div>
            <div>_ga</div>
            <div>App statistics</div>
            <div>1 year</div>
          </div>
          <div class="cookies-table-row">
            <div>Google</div>
            <div>_ga_GT89D0WDBG</div>
            <div>App statistics</div>
            <div>1 year</div>
          </div>
          <div class="cookies-table-row">
            <div>Fullstory</div>
            <div>fs_lua</div>
            <div>App statistics</div>
            <div>Session</div>
          </div>
          <div class="cookies-table-row">
            <div>Fullstory</div>
            <div>fs_uid</div>
            <div>App statistics</div>
            <div>1 year</div>
          </div>
          <div class="cookies-table-row">
            <div>Sentry</div>
            <div>-</div>
            <div>Error monitoring</div>
            <div>-</div>
          </div>
        </div>
      </div>
    </shared-labeled-value-inline-container>

    <shared-labeled-value-inline-container
      class="w-100"
      contentStyleClass="bg-gray-5 p-4 flex-column gap-3"
      [hideHeader]="true">
      <div class="text-20 bold-800">Managing cookies</div>
      <div class="text-14">
        You can turn analytics cookies on or off at any time by using the toggle below. If you do
        not agree to the use of necessary cookies, you should stop using our site as these cannot be
        deactivated.<br /><br />
        Alternatively, your browser may allow you to turn off all cookies. Search your 'Help'
        section in the browser menu, or Google 'How do I turn off cookies' to find detailed
        instructions.
      </div>
    </shared-labeled-value-inline-container>

    <shared-labeled-value-inline-container
      class="w-100 text-14"
      contentStyleClass="bg-gray-5 flex-column py-1"
      headline="Cookie Settings">
      <div
        class="grid layout-auto-fr align-items-center gap-3 bold-500 px-4 py-3 border-bottom border-color-light">
        <p-toggleswitch [ngModel]="true" disabled />
        <span class="bold-700"> Necessary Cookies </span>
      </div>

      <div class="grid layout-auto-fr align-items-center gap-3 bold-500 px-4 py-3">
        <p-toggleswitch [formControl]="analyticsCookieForm" />
        <span class="bold-700"> Analytics Cookies </span>
      </div>
    </shared-labeled-value-inline-container>
  </div>
</div>
